/**
 * Shared helper functions for report control components
 * Used by ReportControls.vue, CustomReportFormDialog.vue, and ReportShareDialog.vue
 */

export const SCHEMA_FIELDS = [
  'min',
  'max',
  'options',
  'default',
  'placeholder',
  'start_min',
  'start_max',
  'end_min',
  'end_max',
  'all_time',
  'pid',
  'params',
  'meta',
];

/**
 * Maps control key/config to the appropriate component name
 */
export function getControlComponent(key, config) {
  if (config.hidden) {
    return '';
  }

  if (key.startsWith('tracker_name')) {
    return 'ReportTrackerNames';
  }

  if (key === 'group' || key === 'groups') {
    return 'ReportGroups';
  }

  if (key === 'group_by' || key === 'field' || key === 'fields') {
    return 'ReportContactField';
  }

  if (key === 'campaign') {
    return 'ReportCampaign';
  }

  if (key === 'custom_object') {
    return 'ReportCustomObjects';
  }

  if (key === 'contact_filters') {
    return 'ReportContactFilter';
  }

  if (key === 'contact') {
    return 'ReportContacts';
  }

  if (config.type === 'date') {
    return 'DateField';
  }

  if (config.type === 'object') {
    return 'ReportObject';
  }

  if (key === 'office_pattern') {
    return 'ReportOfficePattern';
  }

  if (config.type === 'timeframe') {
    return 'ReportTimeframe';
  }

  if (config.options) {
    return 'ReportOptionList';
  }

  if (config.type === 'string') {
    return 'TextField';
  }

  if (['start_time', 'end_time'].includes(key)) {
    return 'TextField';
  }

  if (config.type === 'bool') {
    return 'CheckboxField';
  }

  if (key === 'user') {
    return 'UserListField';
  }

  if (config.type === 'int') {
    return 'NumberField';
  }

  return '';
}

/**
 * Builds schema object for a control component
 */
export function buildControlSchema(config, options = {}) {
  const schema = {
    title: config.title,
    label: config.title,
    help: config.desc,
    multiple: !!config.multiple,
    dark: false,
    ...options,
  };

  if (config?.campaignType) {
    schema.campaignType = config.campaignType;
  }

  SCHEMA_FIELDS.forEach((field) => {
    if (typeof config[field] !== 'undefined') {
      schema[field] = config[field];
    }
  });

  return schema;
}

/**
 * Gets input value from filters for a given config
 */
export function getInputValue(filters, config) {
  let v = filters[config.param];

  if (config.type === 'bool') {
    v = !!(v === 'false' ? false : v || config.default);
  }

  if (typeof v !== 'undefined') {
    return v;
  }

  return '';
}

/**
 * Parses input event - handles both direct values and {param, value} objects
 */
export function parseInputEvent(config, event) {
  let param = config.param;
  let value = event;

  if (event && typeof event === 'object' && event.param) {
    param = event.param;
    value = event.value;
  }

  return { param, value };
}
